var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse, _ellipse2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 160,
    viewBox: "0 0 197 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9958 71.2947C78.2799 74.5119 88.0075 86.5092 91.602 92.1291C91.6114 92.1437 91.6111 92.1614 91.6024 92.1763C91.5755 92.2222 91.6358 92.2706 91.6752 92.2349C94.9553 89.2616 99.0538 87.3749 103.5 87.3749C108.036 87.3749 112.211 89.3391 115.524 92.4178C115.646 92.5314 115.853 92.3705 115.769 92.2265C115.742 92.1808 115.741 92.1263 115.77 92.0817C119.389 86.4421 129.091 74.5029 139.346 71.2947C148.86 68.3186 160.123 69.3126 165.637 70.3628C166.261 70.4814 166.562 71.176 166.232 71.7177C162.745 77.4389 154.851 87.8281 146.399 91.0597C138.462 94.0938 126.801 95.2327 120.162 95.51C119.395 95.542 118.958 96.4291 119.367 97.0789C121.654 100.712 123 104.987 123 109.215C123 110.583 122.82 111.88 122.488 113.102C122.399 113.433 122.481 113.787 122.708 114.044C124.796 116.4 126 119.107 126 121.875C126 129.883 113.125 135.375 103.5 135.375C93.8747 135.375 80.9998 129.883 80.9998 121.875C80.9998 119.107 82.2034 116.4 84.2917 114.044C84.5188 113.787 84.6008 113.433 84.5112 113.102C84.1798 111.88 83.9998 110.583 83.9998 109.215C83.9998 104.98 85.3495 100.699 87.6422 97.0631C88.0508 96.415 87.6181 95.5302 86.8527 95.4958C80.1637 95.1953 68.7509 94.0446 60.9432 91.0597C52.4903 87.8281 44.5965 77.4389 41.1095 71.7177C40.7794 71.176 41.0812 70.4814 41.7044 70.3627C47.2183 69.3126 58.4821 68.3185 67.9958 71.2947Z",
    fill: "url(#paint0_linear_1_119)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35559 73.4182V75.0909",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59985 74.3244L3.96672 75.7314",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00024 78.0703H2.93298",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44214 81.8825L3.80901 80.4755",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35559 82.3392V80.6664",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14324 81.2242L8.02808 80.1091",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3743 78.4361H9.70154",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2594 74.5331L9.14429 75.6482",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.126 0.374878V1.49004",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.781 3.72034H93.8962",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.126 7.06601V5.95085",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.915 3.72037H97.7998",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4467 47.2113V48.884",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4294 52.2298H28.1022",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4467 56.6906V55.0178",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9081 52.2298H34.2354",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.468 108.01C152.801 108.01 153.881 109.091 153.881 110.424C153.881 111.758 152.801 112.838 151.468 112.838C150.136 112.838 149.055 111.758 149.055 110.424",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M162.483 139.742C162.782 141.823 161.337 143.752 159.256 144.05C157.175 144.348 155.247 142.903 154.949 140.822C154.651 138.741 156.095 136.812 158.176 136.514",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.513 86.1109C163.946 85.664 166.142 83.9116 166.65 82.0262C167.111 83.6929 169.044 85.664 170.788 85.8131C168.825 86.5082 166.948 88.5731 166.65 90.1952C166.448 88.5418 163.852 86.352 162.513 86.1109Z",
    fill: "#EBECEE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4285 107.267C16.1451 107.043 17.2429 106.167 17.4971 105.224C17.7276 106.057 18.6937 107.043 19.5657 107.118C18.5844 107.465 17.6462 108.498 17.4971 109.309C17.3958 108.482 16.0978 107.387 15.4285 107.267Z",
    fill: "#EBECEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7285 29.7027C28.7285 30.7368 27.8906 31.5744 26.8573 31.5744C25.8235 31.5744 24.9861 30.7368 24.9861 29.7027C24.9861 28.6691 25.8235 27.831 26.8573 27.831C27.8906 27.831 28.7285 28.6691 28.7285 29.7027Z",
    fill: "#D1D8DF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.23 147.219C139.23 148.946 137.829 150.347 136.102 150.347C134.374 150.347 132.974 148.946 132.974 147.219C132.974 145.491 134.374 144.09 136.102 144.09C137.829 144.09 139.23 145.491 139.23 147.219Z",
    fill: "#EBECEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 26.2526C197 27.6233 195.889 28.7341 194.519 28.7341C193.149 28.7341 192.039 27.6233 192.039 26.2526C192.039 24.8818 193.149 23.771 194.519 23.771C195.889 23.771 197 24.8818 197 26.2526Z",
    fill: "#EBECEE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6987 142.15C63.6987 143.014 62.9986 143.714 62.1347 143.714C61.2713 143.714 60.5712 143.014 60.5712 142.15C60.5712 141.286 61.2713 140.585 62.1347 140.585C62.9986 140.585 63.6987 141.286 63.6987 142.15Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7695 17.6779C62.7695 18.712 61.9317 19.5496 60.8983 19.5496C59.865 19.5496 59.0271 18.712 59.0271 17.6779C59.0271 16.6443 59.865 15.8062 60.8983 15.8062C61.9317 15.8062 62.7695 16.6443 62.7695 17.6779Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.499 159.473C109.304 159.928 107.965 159.327 107.51 158.132C107.056 156.936 107.656 155.597 108.852 155.142C110.047 154.687 111.385 155.288 111.84 156.484C112.296 157.68 111.695 159.018 110.499 159.473Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.460446,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5,
    cy: 103.875,
    rx: 1.5,
    ry: 2.5,
    fill: "#ABB4C4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.5,
    cy: 103.875,
    rx: 1.5,
    ry: 2.5,
    fill: "#ABB4C4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.464 98.0399C121.216 95.8117 126.9 88.0378 129.647 84.4293C135.496 76.3703 149.077 71.9541 139.685 72.4502C132.372 72.8365 120.199 85.9989 114.593 93.0543C114.328 93.3881 114.323 93.8553 114.586 94.191C116.493 96.6255 119.769 100.1 120.464 98.0399Z",
    fill: "url(#paint1_linear_1_119)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8785 98.0399C86.1267 95.8117 80.4432 88.0378 77.6954 84.4293C71.847 76.3703 58.2662 71.9541 67.6573 72.4502C74.9703 72.8365 87.1436 85.9989 92.7499 93.0543C93.0152 93.3881 93.0197 93.8553 92.7568 94.191C90.8498 96.6255 87.5734 100.1 86.8785 98.0399Z",
    fill: "url(#paint2_linear_1_119)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.301 123.45C105.103 123.211 106.792 122.615 107.804 121.595C108.582 120.811 107.723 119.826 106.619 119.826H101.083C99.9784 119.826 99.1202 120.811 99.8982 121.595C100.91 122.615 102.599 123.211 103.401 123.45C103.696 123.537 104.006 123.537 104.301 123.45Z",
    stroke: "#ABB4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104 123.375C104 127.793 101.761 131.375 99 131.375",
    stroke: "#ABB4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109 131.375C106.239 131.375 104 127.793 104 123.375",
    stroke: "#ABB4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.691 71.2418C118.835 76.5178 115.334 86.1505 114.816 90.3073C112.185 94.2643 105.606 88.3888 106.802 86.3503C107.998 84.3119 109.314 80.8345 110.151 77.9567C110.988 75.0789 110.032 72.3209 106.802 68.6038C103.573 64.8866 105.367 59.3708 105.606 56.373C105.845 53.3753 110.39 50.8572 108.477 55.6536C106.563 60.4499 110.151 63.4477 111.706 65.7259C112.95 67.5486 116.53 69.6829 118.165 70.5223C119.361 69.7229 122.16 67.5006 123.787 65.0065C125.82 61.8889 126.777 59.3708 121.753 51.4568C116.73 43.5428 117.567 40.545 118.165 38.8663C118.763 37.1876 120.557 37.907 120.318 39.5858C120.079 41.2645 125.103 47.4998 128.691 51.4568C131.562 54.6224 132.598 59.091 132.758 60.9296C133.396 60.6098 135.27 59.8504 137.662 59.3708C147.948 56.2531 148.786 42.8233 149.503 39.5858C150.221 36.3482 146.513 30.2329 149.503 32.0315C152.494 33.8301 154.168 45.4613 152.733 51.4568C151.297 57.4522 146.513 61.0495 146.513 61.8889C146.513 62.7282 152.613 65.4861 146.513 65.0065C140.413 64.5269 141.011 64.6468 128.691 71.2418Z",
    fill: "#EDF0F7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3511 71.2418C87.207 76.5178 90.7077 86.1505 91.226 90.3073C93.8574 94.2643 100.436 88.3888 99.2399 86.3503C98.0438 84.3119 96.7281 80.8345 95.8908 77.9567C95.0535 75.0789 96.0104 72.3209 99.2399 68.6038C102.469 64.8866 100.675 59.3708 100.436 56.373C100.197 53.3753 95.6516 50.8572 97.5654 55.6536C99.4792 60.4499 95.8908 63.4477 94.3359 65.7259C93.0919 67.5486 89.5115 69.6829 87.8769 70.5223C86.6807 69.7229 83.8818 67.5006 82.2551 65.0065C80.2217 61.8889 79.2648 59.3708 84.2885 51.4568C89.3122 43.5428 88.4749 40.545 87.8769 38.8663C87.2788 37.1876 85.4846 37.907 85.7239 39.5858C85.9631 41.2645 80.9394 47.4998 77.3511 51.4568C74.4804 54.6224 73.4437 59.091 73.2843 60.9296C72.6463 60.6098 70.7724 59.8504 68.3802 59.3708C58.0936 56.2531 57.2563 42.8233 56.5387 39.5858C55.821 36.3482 59.529 30.2329 56.5387 32.0315C53.5484 33.8301 51.8738 45.4613 53.3092 51.4568C54.7445 57.4522 59.529 61.0495 59.529 61.8889C59.529 62.7282 53.4288 65.4861 59.529 65.0065C65.6291 64.5269 65.0311 64.6468 77.3511 71.2418Z",
    fill: "#EDF0F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_119",
    x1: 43.4806,
    y1: 134.122,
    x2: 41.938,
    y2: 74.0803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_119",
    x1: 113.882,
    y1: 95.2224,
    x2: 125.613,
    y2: 66.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_119",
    x1: 93.4608,
    y1: 95.2224,
    x2: 81.7297,
    y2: 66.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.0ac62831f36ce29d14e3a0b250695980.svg";
export { ForwardRef as ReactComponent };